module.exports = __webpack_public_path__ + "025a29a6ed192c501a784c106a37530c.svg";